export default __webpack_public_path__ + "static/media/ao.3d13492f.svg";